
import { userConstants, alertConstants, orgConstants } from "../constants";
import { userService } from "../services/user.service";
import { alertActions } from "./alert.actions.js";
import { history } from "../helpers";
import Cookies from "universal-cookie";

export const userActions = {
  login,
  verifyMfa,
  tokenLogin,
  cookieLogin,
  logout,
  getList,
  refreshToken,
  authenticateTab,
  createUser,
  editUser,
  requestPasswordReset,
  editPassword,
  getUserDetail,
  getAllRoles,
  assignDoctypeToUser,
  removeDoctypeFromUser
};

function login(email, password) {
  const user = {
    email: email,
    password: password,
  };
  return (dispatch) => {
    dispatch(loginAlert("signing in..."));
    dispatch(request(user));

    userService.login(user).then(
      (user) => {
        dispatch(clearAlert());

        console.log(user);

        if (user.use_mfa) {
          history.push("/mfa/?u=" + user.user_id + '&t=' + user.mfa_type);
        } else {
          dispatch(refreshToken(user.token));
          dispatch(currentOrg(user.org_id));
          dispatch(success(user));

          const cookies = new Cookies();
          cookies.set("uid", user.user_id, { path: "/" });
          history.push("/org/" + user.org_id + "/dealjackets");
        }

      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
      }
    );
  };

  function currentOrg(org_id) {
    return { type: orgConstants.ORG_SET_CURRENT_ORG_ID, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function loginAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function verifyMfa(code, user_id) {
  const req = {
    code: code,
    user_id: user_id,
  };
  return (dispatch) => {
    dispatch(loginAlert("verifying code..."));
    dispatch(request(req));

    userService.verifyMfa(req).then(
      (user) => {
        dispatch(clearAlert());

        console.log(user);

        dispatch(refreshToken(user.token));
        dispatch(currentOrg(user.org_id));
        dispatch(success(user));

        const cookies = new Cookies();
        cookies.set("uid", user.user_id, { path: "/" });
        history.push("/org/" + user.org_id + "/dealjackets");

      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
      }
    );
  };

  function currentOrg(org_id) {
    return { type: orgConstants.ORG_SET_CURRENT_ORG_ID, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function loginAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}



function tokenLogin(token, location) {
  const input = {
    token: token
  };

  return (dispatch) => {
    dispatch(tokenLoginAlert("authenticating with token..."));
    dispatch(request(input));

    userService.tokenLogin(input).then(
      (user) => {
        dispatch(refreshToken(user.token));
        dispatch(currentOrg(user.org_id));
        dispatch(success(user));
        dispatch(clearAlert());
        const cookies = new Cookies();
        cookies.set("uid", user.user_id, { path: "/" });
        const searchParams = new URLSearchParams(location.search);
        searchParams.delete('jwt');
        history.push(location.pathname + '?' + searchParams.toString());
        //history.push(location.pathname + location.search);

      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error.message));
      }
    );
  }

  function currentOrg(org_id) {
    return { type: orgConstants.ORG_SET_CURRENT_ORG_ID, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function tokenLoginAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }
}

function cookieLogin(user_id, redirect_path) {
  const user = {
    user_id: Number(user_id),
  };

  return (dispatch) => {
    dispatch(loginAlert("signing in..."));
    dispatch(request(user));

    userService.cookieLogin(user).then(
      (user) => {
        dispatch(refreshToken(user.token));
        dispatch(currentOrg(user.org_id));
        dispatch(success(user));
        dispatch(clearAlert());
        history.push(redirect_path);
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function currentOrg(org_id) {
    return { type: orgConstants.ORG_SET_CURRENT_ORG_ID, org_id };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function request(user) {
    return { type: userConstants.COOKIE_LOGIN_REQUEST, user };
  }
  function loginAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.COOKIE_LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.COOKIE_LOGIN_FAILURE, error };
  }
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

function getList(user_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching users..."));
    dispatch(listRequest(user_id));

    userService.getList(user_id).then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function listRequest(user_id) {
    return { type: userConstants.USER_GETLIST_REQUEST, user_id };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: userConstants.USER_GETLIST_SUCCESS, list };
  }
  function failure(message) {
    return { type: userConstants.USER_GETLIST_FAILURE, message };
  }
}

function getUserDetail(user_id) {
  return (dispatch) => {
    dispatch(fetchAlert("fetching user detail..."));
    dispatch(detailRequest(user_id));

    userService.getDetail(user_id).then(
      (user) => {
        dispatch(refreshToken(user.newToken));
        dispatch(clearAlert());
        dispatch(success(user));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(error));
      }
    );
  };

  function fetchAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function detailRequest(user_id) {
    return { type: userConstants.USER_GET_DETAIL_REQUEST, user_id };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.USER_GET_DETAIL_SUCCESS, user };
  }
  function failure(message) {
    return { type: userConstants.USER_GET_DETAIL_FAILURE, message };
  }
}

function refreshToken(token) {
  return (dispatch) => {
    dispatch(refreshToken(token));
  };

  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
}

function authenticateTab(jwt) {
  return (dispatch) => {
    dispatch(refreshToken(jwt));
  };
}

function createUser(userRequest) {
  return (dispatch) => {
    dispatch(uploadAlert("creating user"));
    dispatch(createRequest(userRequest));

    userService.createUser(userRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
        dispatch(getList());
        history.push("/users", { message: "User created!" });
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(userRequest));
        dispatch(alertActions.error("There was a problem creating the user: " + error));
      }
    );
  };
  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function createRequest(userRequest) {
    return { type: userConstants.USER_CREATE_REQUEST, userRequest };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.USER_CREATE_SUCCESS, user };
  }
  function failure(user) {
    return { type: userConstants.USER_CREATE_FAILURE, user };
  }
}

function editUser(userRequest) {
  return (dispatch) => {
    dispatch(editAlert("editing user"));
    dispatch(editRequest(userRequest));

    userService.editUser(userRequest).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
        dispatch(success(response));
        dispatch(getList());
        history.push("/user/" + response.user_id, { message: "User created!" });
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(userRequest));
        dispatch(alertActions.error("There was a problem editing the user."));
      }
    );
  };
  function editAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function editRequest(userRequest) {
    return { type: userConstants.USER_EDIT_REQUEST, userRequest };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.USER_EDIT_SUCCESS, user };
  }
  function failure(user) {
    return { type: userConstants.USER_EDIT_FAILURE, user };
  }
}

function getAllRoles() {
  return (dispatch) => {
    dispatch(uploadAlert("retrieving roles"));
    dispatch(getRequest());

    userService.getAllRoles().then(
      (list) => {
        dispatch(refreshToken(list.newToken));
        dispatch(clearAlert());
        dispatch(success(list));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure());
        dispatch(alertActions.error("There was a problem retriving the user detail."));
      }
    );
  };
  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function getRequest() {
    return { type: userConstants.USER_GET_ALL_ROLES_REQUEST };
  }
  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(list) {
    return { type: userConstants.USER_GET_ALL_ROLES_SUCCESS, list };
  }
  function failure() {
    return { type: userConstants.USER_GET_ALL_ROLES_FAILURE };
  }
}

function requestPasswordReset(email) {
  return (dispatch) => {
    dispatch(uploadAlert("requesting password reset"));
    dispatch(resetRequest(email));

    userService.resetPassword(email).then(
      (response) => {
        dispatch(clearAlert());
        dispatch(success(response));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(email));
        dispatch(alertActions.error("Unable to reset password."));
      }
    );
  };
  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function resetRequest(email) {
    return { type: userConstants.USER_PWD_RESET_REQUEST, email };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.USER_PWD_RESET_SUCCESS, user };
  }
  function failure(user) {
    return { type: userConstants.USER_PWD_RESET_FAILURE, user };
  }
}

function editPassword(user, code) {
  return (dispatch) => {
    dispatch(uploadAlert("updating password"));
    dispatch(resetRequest(user, code));

    userService.editPassword(user, code).then(
      (response) => {
        dispatch(clearAlert());
        dispatch(success(response));
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(failure(user));
        dispatch(alertActions.error("Unable to reset password."));
      }
    );
  };
  function uploadAlert(message) {
    return { type: alertConstants.SPINNER, message };
  }
  function resetRequest(user, code) {
    return { type: userConstants.USER_PWD_RESET_REQUEST, user, code };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
  function success(user) {
    return { type: userConstants.USER_PWD_RESET_SUCCESS, user };
  }
  function failure(user) {
    return { type: userConstants.USER_PWD_RESET_FAILURE, user };
  }
}

function assignDoctypeToUser(requestObject) {
  return (dispatch) => {
    dispatch(alert("modifying doctype assignments..."));

    userService.assignDoctypeToUser(requestObject).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(alertActions.error("There was a problem modifying doctype assignments."));
      }
    );
  };
  function alert(message) {
    return { type: alertConstants.SPINNER, message };
  }

  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }

}

function removeDoctypeFromUser(requestObject) {
  return (dispatch) => {
    dispatch(alert("modifying doctype assignments..."));

    userService.removeDoctypeFromUser(requestObject).then(
      (response) => {
        dispatch(refreshToken(response.newToken));
        dispatch(clearAlert());
      },
      (error) => {
        dispatch(clearAlert());
        dispatch(alertActions.error("There was a problem modifying doctype assignments."));
      }
    );
  };
  function alert(message) {
    return { type: alertConstants.SPINNER, message };
  }

  function refreshToken(token) {
    return { type: userConstants.TOKEN_REFRESH, token };
  }
  function clearAlert() {
    return { type: alertConstants.CLEAR };
  }
}